import { api } from '@/lib/api';
import type { IApiResponse, IRepository, IRepositoryConnections } from '@skystone/shared';

export const repositoryApi = {
  getAll: async (options?: {
    includeArchived?: boolean;
    includeUnassigned?: boolean;
    productId?: string;
    search?: string;
  }): Promise<IRepository[]> => {
    const params = new URLSearchParams();
    if (options?.includeArchived) params.set('includeArchived', 'true');
    if (options?.includeUnassigned !== undefined) params.set('includeUnassigned', String(options.includeUnassigned));
    if (options?.productId) params.set('productId', options.productId);
    if (options?.search) params.set('search', options.search);
    const query = params.toString();
    const url = query ? `/repositories?${query}` : '/repositories';
    const result = await api.get<IApiResponse<IRepository[]>>(url);
    return result.data;
  },

  getById: async (id: string): Promise<IRepository> => {
    const result = await api.get<IApiResponse<IRepository>>(`/repositories/${id}`);
    return result.data;
  },

  getConnections: async (includeArchived = false): Promise<IRepositoryConnections> => {
    const query = includeArchived ? '?includeArchived=true' : '';
    const result = await api.get<IApiResponse<IRepositoryConnections>>(`/repositories/connections${query}`);
    return result.data;
  },
};
